
  Vue.component('vue-datatable', {
    props: {
      id: { type: String, required: true },
      visible: { type: Boolean, default: true },
      columnsDefinition: [],
      actionsList: [],
      statusList: [],
      data: [],
      selectedId: { type: Number }
    },
    data() {
      return {
        sortColumn: null,
        sortDirection: 1,
        filter: null
      }
    },
    template: '#vue-datatable',
    computed: {
      computedData() {
        const retVal = [...this.data]
        if (this.filter) {
          console.log('filter')
        }
        if (this.sortDirection != 1) {
          const sortDirection = this.sortDirection == 2 ? 1 : -1
          retVal.sort((a, b) => (a[this.sortColumn] > b[this.sortColumn] ? sortDirection : -sortDirection))
        }
        return retVal
      }
    },
    watch: {},
    methods: {
      dummy(param) {},
      formatDate(value, format) {
        return moment(value).format(format)
      },
      changeSorting(event, sortColumn) {
        if (sortColumn == this.sortColumn) {
          const direction = (this.sortDirection % 3) + 1
          this.sortDirection = direction
          if (direction === 1) this.sortColumn = ''
        } else {
          this.sortDirection = 2
          this.sortColumn = sortColumn
        }
      },
      checkVisibility(hideWhen, showWhen, rowItem) {
        let show = !showWhen
        if (hideWhen) {
          const entries = Object.entries(hideWhen)
          for (const [key, value] of entries) {
            show = show && rowItem[key] !== value
          }
        }
        if (showWhen) {
          const entries = Object.entries(showWhen)
          for (const [key, value] of entries) {
            show = show || rowItem[key] === value
          }
        }
        return show
      }
    },
    mounted() {
      // EventBus.$on('vnShow', this.vnShow)
    },
    beforeDestroy() {
      // EventBus.$off('vnShow', this.vnShow)
    }
  })
